var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.139,
    height: 14.139,
    viewBox: "0 0 14.139 14.139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n\t\t.upload-icon-background {fill:none;}\r\n\t\t.upload-icon-background,.upload-icon-arrow-tip{stroke:#22b3b3;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}\r\n\t\t.upload-icon-arrow-tip{fill:none;}\r\n\t"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "upload-icon-background",
    d: "M15.139,15v2.7a1.349,1.349,0,0,1-1.349,1.349H4.349A1.349,1.349,0,0,1,3,17.7V15",
    transform: "translate(-3 -6.907)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "upload-icon-arrow-tip",
    d: "M13.744,6.372,10.372,3,7,6.372",
    transform: "translate(-4.302 -3)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "upload-icon-arrow-tip",
    y2: 8,
    transform: "translate(6)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.3c7e8f1e7dad4b8555f84fac65218fe0.svg";
export { ForwardRef as ReactComponent };